import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button, Typography } from 'antd'
import { textSubtitle } from '../../styles/AuthStyles'
import { SupportAssistance } from '../SupportAssistance'

export const InvitationInvalid = () => {
  const { t } = useTranslation()

  return (
    <div
      className='text-center'
      data-testid='invitation-invalid'
    >
      <Typography.Title
        level={2}
        style={{ marginBottom: '16px', fontWeight: 400 }}
      >
        {t('phone_auth_invitation_invalid_title')}
      </Typography.Title>
      <Typography.Text
        type='secondary'
        style={{ ...textSubtitle, marginBottom: '40px' }}
      >
        {t('phone_auth_invitation_invalid_text')}
      </Typography.Text>
      <Link to='/patient-portal/login'>
        <Button
          type='primary'
          size='large'
          block
          data-testid='invitation-invalid-sign-in'
        >
          {t('phone_auth_sign_in')}
        </Button>
      </Link>
      <SupportAssistance data-testid='invitation-invalid-assistance' />
    </div>
  )
}
